import { useState, useEffect } from 'react'
import formatNumberByLocale from './format-number-by-locale'
import { useTranslation } from 'react-i18next'
import { getNumberFromLocale } from './get-number-form-locale'
import i18next from 'i18next'
import isNil from 'lodash/isNil'

const useFormatNumberByLocale = (
  rawNumber,
  minimumFractionDigits = 0,
  locale = i18next.language?.split('_')?.[0]
) => {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState(null)
  useEffect(
    () =>
      setInputValue(
        formatNumberByLocale(
          getNumberFromLocale(isNil(rawNumber) ? '' : rawNumber.toString(), locale),
          minimumFractionDigits
        )
      ),
    [rawNumber, minimumFractionDigits, t, locale]
  )
  return inputValue
}

export default useFormatNumberByLocale
